import React from "react";

import clsx from "clsx";

import { GenericTooltip } from "@components/tooltip-container";

interface RadioProps<T> {
  label: string | React.ReactNode;
  value: T;
  onChange: (value: T) => void;
  checked?: boolean;
  isDisabled?: boolean;
  labelClassName?: string;
  inputClassName?: string;
  disabledTooltip?: string;
}

export const Radio = <T extends string>({
  label,
  value,
  onChange,
  checked = false,
  isDisabled = false,
  labelClassName,
  inputClassName,
  disabledTooltip,
}: RadioProps<T>) => (
  <span className="flex items-center">
    <input
      id={value}
      className={clsx(
        { "cursor-pointer": !isDisabled, "cursor-not-allowed": isDisabled },
        inputClassName,
      )}
      type="radio"
      disabled={isDisabled}
      value={value}
      onChange={(e) => onChange(e.target.value as T)}
      checked={checked}
    />
    <GenericTooltip
      showTooltip={!!disabledTooltip && isDisabled}
      content={disabledTooltip}
      noInfoCircle
      placement="top-start"
    >
      <label
        className={clsx(
          "ml-2 my-0.5",
          { "cursor-pointer": !isDisabled, "cursor-not-allowed": isDisabled },
          labelClassName,
        )}
        htmlFor={value}
      >
        {label}
      </label>
    </GenericTooltip>
  </span>
);
